import levelTwogImage from '../../constants/imageFiles/levelTwogImage.jpeg';
import { Grid } from '@mui/material'
import AnswerBox from '../AnswerBox';

export default function LevelTwog() {
    console.log("Good grief.")
    return (
        <div>

            <Grid container spacing={1} alignItems='center' justifyContent="center">
                <Grid item xs={9}>
                    <img
                        style={{ maxWidth: "100%" }}
                        src={levelTwogImage}
                        alt="A white dog with black ears."
                    />
                </Grid>
            </Grid>
            <br></br>
            < AnswerBox 
                            correctAnswer = 'snoopy'
                            hint = {<div>He's a real Ace</div>}
                            nextLevel = '../levels/level2h'
                            />
        </div>
    )
};